import { FormControl } from '@chakra-ui/react';
import { useClassFiltersStore } from '@stores/classes';
import Select from 'react-select';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const classTypeOptions = [
  { value: 'yoga', label: 'Yoga' },
  { value: 'pilates', label: 'Pilates' },
  { value: 'reformer', label: 'Reformer' },
];

export function RiiseFilter() {
  const classType = useClassFiltersStore((state) => state.classType);
  const setClassType = useClassFiltersStore((state) => state.setClassType);
  const location = useLocation();
  const navigate = useNavigate();

  // Vérifier si l'URL contient un type de cours et le définir
  useEffect(() => {
    const coursMatch = location.pathname.match(/\/cours\/([^/]+)(?:$|\/)/);
    if (coursMatch) {
      const courseType = coursMatch[1];
      if (classTypeOptions.some((option) => option.value === courseType)) {
        setClassType(courseType);
        // Nettoyer l'URL en préservant le studio s'il existe
        const studioMatch = location.pathname.match(/\/studio\/(\d+)/);
        const newPath = studioMatch ? `/studio/${studioMatch[1]}` : '/';
        navigate(newPath, { replace: true });
      }
    }
  }, [location.pathname, setClassType, navigate]);

  return (
    <FormControl>
      <Select
        className="classTypeSelect"
        placeholder="Type de cours"
        options={classTypeOptions}
        value={classTypeOptions.find((option) => option.value === classType)}
        onChange={(option) => setClassType(option ? option.value : null)}
        isClearable
      />
    </FormControl>
  );
}
